import React from 'react'
import { Breadcrumbs } from 'src/components/Breadcrumbs'
import Image from 'next/image'
import styles from './styles.module.scss'
import ListAuthor from 'src/components/ListAuthor'
import { useAppIntl } from 'src/i18n'

type FirstContainerProps = {
  data: any
}

const Header: React.FC<FirstContainerProps> = ({ data }) => {
  const intl = useAppIntl()
  const listsBreadrumbs = [{ breadcrumb: 'Reviews', href: '/review' }] // you might need to adjust this
  return (
    <div className={styles.main}>
      <div className={styles.header}>
        <Breadcrumbs
          items={listsBreadrumbs}
          lastItem={data?.title}
          wrapperClassName={styles.breadcrumbs}
        />
        <h1 className={styles.title}>{data?.title}</h1>
        <ListAuthor
          authorData={{
            authorSlug: data?.author?.data?.attributes.slug,
            authorImage:
              data?.author?.data?.attributes?.image?.data?.attributes.url,
            authorFullName: data?.author?.data?.attributes?.fullName,
            createdAt: data?.publishedAt,
          }}
        />
      </div>
      <div className={styles.summaryHeader}>
        <div className={styles.logo}>
          <a href={data.affiliateLink} rel='noopener noreferrer nofollow'>
            <Image
              src={data.thumbnail.data.attributes.url}
              alt={data.thumbnail.data.attributes.alternativeText}
              width={275}
              height={275}
            />
          </a>
        </div>
        <div className={styles.score}>
          <div className={styles.totalScore}>
            <p>
              <span>{data?.ratings?.data[0]?.attributes?.score}</span> / 10
            </p>
            <Image
              src='/assets/icons/icon-star-green.svg'
              alt={data.thumbnail.data.attributes.alternativeText}
              width={30}
              height={30}
            />
          </div>
        </div>
        <div className={styles.summary}>
          <h2>{intl.t('review.item.summary')}</h2>
          <p>{data.summary}</p>
        </div>
        <div className={styles.pros}>
          <h2>{intl.t('review.item.pros')}</h2>
          {data?.pros.data?.slice().map((pro, index) => (
            <div key={index} className={styles.icons}>
              <Image
                src='/assets/icons/icon-check-circle.svg'
                alt='plus'
                height={17}
                width={17}
              />
              <p>{pro.attributes?.description}</p>
            </div>
          ))}
        </div>
        <div className={styles.cons}>
          <h2>{intl.t('review.item.cons')}</h2>
          {data?.cons.data?.slice().map((con, index) => (
            <div key={index} className={styles.icons}>
              <Image
                src='/assets/icons/icon-cross-circle.svg'
                alt='plus'
                height={17}
                width={17}
              />
              <p>{con.attributes?.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Header
